// This file is automatically generated. Do not edit manually.

import { CustomerOrderOffer } from "src/api/generated/erp/db/types/tables/customerOrderOffer";
import { ObjectAttributeValueWithFieldId } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeValueWithFieldId";
import { CustomerOrderOfferUpdateService_UpdateRequest } from "src/api/generated/erp/sales/customerOrderOffer/service/customerOrderOfferUpdateService";
import { ObjectAttributeField } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeField";
import { ObjectAttribute } from "src/api/generated/erp/db/types/tables/objectAttribute";
import { ContractualTerm } from "src/api/generated/erp/db/types/tables/contractualTerm";
import { Currency } from "src/api/generated/erp/db/types/tables/currency";
import { Customer } from "src/api/generated/erp/db/types/tables/customer";
import { CustomerAddress } from "src/api/generated/erp/db/types/tables/customerAddress";
import { CustomerOfferType } from "src/api/generated/erp/db/types/tables/customerOfferType";
import { CustomerOrderOfferView } from "src/api/generated/erp/db/types/tables/customerOrderOfferView";
import { CustomerPriceGroup } from "src/api/generated/erp/db/types/tables/customerPriceGroup";
import { DeliveryMethod } from "src/api/generated/erp/db/types/tables/deliveryMethod";
import { DeliveryTerm } from "src/api/generated/erp/db/types/tables/deliveryTerm";
import { PaymentTerm } from "src/api/generated/erp/db/types/tables/paymentTerm";
import { SalespersonView } from "src/api/generated/erp/db/types/tables/salespersonView";
import { Site } from "src/api/generated/erp/db/types/tables/site";
import { VatCode } from "src/api/generated/erp/db/types/tables/vatCode";
import { VatHandlingType } from "src/api/generated/erp/db/types/tables/vatHandlingType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderOfferEditApi {
	export async function getFormInitData(args: {
		customerOrderOfferId: number | null | undefined;
	}): Promise<CustomerOrderOfferEditApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/getFormInitData",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
			},
		});
		return response as CustomerOrderOfferEditApi_FormInitData;
	}

	export async function insert(args: {
		offer: CustomerOrderOffer;
		attributes?: Array<ObjectAttributeValueWithFieldId>;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/insert",
			method: "POST",
			data: {
				offer: args.offer,
				attributes: args.attributes,
			},
		});
		return response as number;
	}

	export async function update(args: {
		request: CustomerOrderOfferUpdateService_UpdateRequest;
		attributes?: Array<ObjectAttributeValueWithFieldId> | null | undefined;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/update/v2",
			method: "POST",
			data: {
				request: args.request,
				attributes: args.attributes,
			},
		});
		return response as void;
	}

	export async function delete_(args: { customerOrderOfferIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/delete",
			method: "POST",
			data: {
				customerOrderOfferIds: args.customerOrderOfferIds,
			},
		});
		return response as void;
	}
}

export interface CustomerOrderOfferEditApi_FormInitData {
	attributeFields: Array<ObjectAttributeField>;
	attributeValues: Array<ObjectAttribute>;
	contractualTermOptions: Array<ContractualTerm>;
	currencyOptions: Array<Currency>;
	customer: Customer | null | undefined;
	customerAddresses: Array<CustomerAddress> | null | undefined;
	customerOfferTypeOptions: Array<CustomerOfferType>;
	customerOrderOffer: CustomerOrderOfferView | null | undefined;
	customerPriceGroupOptions: Array<CustomerPriceGroup>;
	deliveryMethodOptions: Array<DeliveryMethod>;
	deliveryTermOptions: Array<DeliveryTerm>;
	offerHasAnyLines: boolean;
	paymentTermOptions: Array<PaymentTerm>;
	salespersonOptions: Array<SalespersonView>;
	siteOptions: Array<Site>;
	vatCodeOptions: Array<VatCode>;
	vatHandlingTypeOptions: Array<VatHandlingType>;
}
